/**
 * Permission modes configuration
 * Single source of truth for all permission structures across the app
 * Used by EditUserProfile.vue and PermissionPresets.vue
 */

const PERMISSION_MODES = [
  {
    key: 'global',
    label: 'Global Permissions',
    items: [
      {
        key: 'global.see_all_jobs',
        label: 'See all jobs (all sites)',
      },
      {
        key: 'global.edit_all_jobs',
        label: 'Edit all visible jobs',
      },
      {
        key: 'global.edit_all_templates',
        label: 'Edit all templates',
      },
    ],
  },
  {
    key: 'admin',
    label: 'Admin Mode',
    sections: [
      {
        title: 'Site Permissions',
        items: [
          {
            key: 'admin.site.edit_primary',
            label: 'Edit primary site information',
          },
          {
            key: 'admin.site.edit_all',
            label: 'Edit all sites information',
          },
          { key: 'admin.site.create', label: 'Create sites' },
        ],
      },
      {
        title: 'User Approvals & Roles',
        items: [
          {
            key: 'admin.approvals.approve_edit_primary',
            label: 'Manage primary site users',
          },
          {
            key: 'admin.approvals.approve_edit_all',
            label: 'Manage all site users',
          },
        ],
      },
      {
        title: 'Instrumentation',
        items: [
          {
            key: 'admin.instrumentation.edit_primary',
            label: 'Edit primary site instrumentation',
          },
          {
            key: 'admin.instrumentation.edit_all',
            label: 'Edit all sites instrumentation',
          },
          {
            key: 'admin.instrumentation.create_edit_types',
            label: 'Create/edit instrument types',
          },
        ],
      },
    ],
  },
  {
    key: 'editor',
    label: 'Editor Mode',
    items: [{ key: 'editor.create_templates', label: 'Create templates' }],
  },
  {
    key: 'publisher',
    label: 'Publisher Mode',
    items: [{ key: 'publisher.create_jobs', label: 'Create jobs' }],
  },
  {
    key: 'inspector',
    label: 'Inspector Mode',
    items: [{ key: 'inspector.leadman_signoff', label: 'Leadman sign off' }],
  },
  {
    key: 'report',
    label: 'Report Mode',
    items: [
      { key: 'report.engineering_review', label: 'Engineering review' },
      { key: 'report.download', label: 'Download report' },
    ],
  },
];

export default PERMISSION_MODES;
